import { ReactNode } from 'react';
import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { formatDate } from '@/helpers/dateHelpers/dateHelpers';
import { TaskDetailsType } from '@/types/dashboardTypes';
import { TasksStatus } from '../../../TasksStatus';
import { Facts } from './styles';
import { COLORS } from '@/styles/colors';

type FactType = {
  label: string;
  children: ReactNode;
};

const Fact = ({ label, children }: FactType) => (
  <Box display='flex' flexDirection='column' gap='3px'>
    <Typography variant='caption' color={COLORS.grey[650]}>
      {label}
    </Typography>
    <Typography variant='bodySmall'>{children}</Typography>
  </Box>
);

export const TaskFacts = ({ task }: { task: TaskDetailsType }) => {
  const dueLabel = task.due_date ? formatDate(task.due_date) : 'Not set';
  const linkedLabel = task.linked_label || '-';

  return (
    <Facts>
      <Fact label='Status'>
        <TasksStatus status={task.status}>{task.status_label}</TasksStatus>
      </Fact>
      <Fact label='Assigned to'>{task.assigned_to_label}</Fact>
      <Fact label='Due'>{dueLabel}</Fact>
      <Fact label='Linked to'>{linkedLabel}</Fact>
    </Facts>
  );
};
